import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { times } from 'lodash';
import _ from 'mudash';
import cn from 'classnames';
import styles from './style.scss';
import Tile from './tile';
import { ListEvent } from './list';

function Columns({ events, settings }) {
  const col = 12 / events.count();
  if (events.count() === 1) {
    return (
      <ListEvent
        key={events.getIn([0, 'id'])}
        event={events.get(0)}
        events={events}
        settings={settings}
      />
    );
  }
  return (
    <Row className={cn(styles.inlineFlex, 'columns')}>
      {times(events.count(), index => (
        <Col xs={col} md={col} className={styles.column}>
          <Tile
            key={events.getIn([index, 'id'])}
            event={events.get(index)}
            events={events}
            settings={settings}
            className={styles.columnTile}
          />
        </Col>
      ))}
    </Row>
  );
}

export default function ColumnLayout({ columns, events, settings }) {
  const eventChunks = _.chunk(events, columns);
  return (
    <div>
      {eventChunks.map(columnEvent => <Columns events={columnEvent} settings={settings} />)}
    </div>
  );
}

Columns.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

ColumnLayout.propTypes = {
  columns: PropTypes.number,
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};



// WEBPACK FOOTER //
// ./src/widget/event_layouts/column_layout.js